:host {
  display: inline-block;
}

:host > div:hover .tooltip, :host > div:active .tooltip {
  visibility: visible;
  z-index: 10;
}

:host([hidden]) {
  display: none;
}

.tooltip-wrapper {
  cursor: default;
  max-width: 520px;
  z-index: 10;
}

.tooltip-wrapper-inner-content {
  display: block;
  font-size: 12px;
  line-height: 14px;
}

.tooltip-wrapper-container {
  display: flex;
}

.tooltip-wrapper-container--pointer {
  cursor: pointer;
}

.tooltip-wrapper-container .tooltip-wrapper-text {
  color: #9fa0a4;
  line-height: 16px;
}

:host(:not([dir="rtl"])) .tooltip-wrapper-container .tooltip-wrapper-text {
  margin-left: 5px;
}

:host([dir="rtl"]) .tooltip-wrapper-container .tooltip-wrapper-text {
  margin-right: 5px;
}

.tooltip-wrapper-container .tooltip-wrapper-text:hover, .tooltip-wrapper-container .tooltip-wrapper-text:active {
  color: #626469;
  cursor: pointer;
}

@media screen and (max-width: 979px) {
  .tooltip-wrapper-container {
    padding: 1em;
    margin: -1em;
  }
}

.tooltip-wrapper-modal-content {
  color: #626469;
  font-size: 14px;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 32px 30px;
}

.tooltip-wrapper-modal-close-button {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E");
  height: 20px;
  width: 20px;
  position: absolute;
  top: 11px;
}

:host(:not([dir="rtl"])) .tooltip-wrapper-modal-close-button {
  right: 11px;
}

:host([dir="rtl"]) .tooltip-wrapper-modal-close-button {
  left: 11px;
}

.tooltip-wrapper-modal-close-button::before {
  content: "";
  display: block;
  top: -10px;
  position: absolute;
  height: 40px;
  width: 40px;
}

:host(:not([dir="rtl"])) .tooltip-wrapper-modal-close-button::before {
  right: -10px;
}

:host([dir="rtl"]) .tooltip-wrapper-modal-close-button::before {
  left: -10px;
}

@media screen and (min-width: 980px) {
  :host {
    position: relative;
  }
}